<!--suppress ALL -->
<template lang="pug">
  div
    .option__head.d-flex.justify-content-between
      strong
        | {{name}}
        template(v-if='0 === min && 0 === max')
          span &nbsp;
        template(v-else-if='min === 0 && max >= 0')
          span.required.valid ({{ count }}/{{ max }})

        template(v-else-if='1 === max && 1 === min')
          span.required(style='display:none;') ( bắt buộc )
          span(style='display:none;') {{ count }}

      span.text-gray(v-if='min === 0 && max !== 0' style='display:none;')
        | Tối thiểu:{{ min }} - Tối đa:{{ max }}

    .option__body

      .d-flex.flex-wrap(v-if='options')
        .option__col(v-for='(op,key) in options')
          .option__checkbox(@click.prevent='addItem(key,op)' :class=" {'is-active' : op.quantity > 0}")
            | {{op.name}}
            span.option__price(v-if='op.ta_price >0') (+{{op.ta_price|formatPrice}})

            template(v-if='options[key].quantity>1')  x {{options[key].quantity}}
            .option__remove(v-if='op.quantity >=1 ' @click.stop='removeItem(key,op)')
              i.fa.fa-close

</template>
<script>
export default {
  props: {
    item: Object,
    update: Boolean,
    min: Number,
    max: Number
  },
  name: 'ProductCustomization',
  data() {


    return {
      name: this.item.name,
      options: [],
      count: 0,
    }
  },
  created() {
    if (this.item.options) {
      this.options = this.item.options.map(function (el) {
        if (typeof el.quantity === "undefined" ) el.quantity = 0;
        return el;
      })
      this.count = _.sumBy(this.options, 'quantity') || 0
    }
  },
  methods: {
    addItem(k,op) {
      //trường hợp ko bắt buộc
      if (this.min === 0 && this.max === 0) {
        op.quantity++;
        this.count++;
        this.$set(this.options,k,op);
        this.$emit('change', {...this.options});
      }
      //trường hợp bắt buộc chọn 1
      else if(this.min === 1 && this.max === 1) {
        if (this.count >= 1 || op.quantity>=1) return;
        op.quantity++;
        this.count++;
        this.$set(this.options,k,op);
        this.$emit('change', {...this.options});
      }
      //trường hợp trong khoảng min và max
      else if(this.min >= 0 && this.max > 0) {

        if (this.count >= this.max) return;
        op.quantity++;
        this.count++;
        this.$set(this.options,k,op);
        this.$emit('change', {...this.options});
      }
    },
    removeItem(k,op) {
      if (this.min === 0 && this.max === 0) {
        this.count = this.count - op.quantity;
        op.quantity=0;
        this.$set(this.options, k, op);
      } else {
        if (this.count > 0 && this.count < this.min) return;

        let index = Object.keys(this.options)[k]
        if (this.options[index]) {
          if (this.options[index].quantity > 0 && this.count >= this.options[index].quantity) {
            this.count = this.count - this.options[index].quantity
            this.options[index].quantity = 0;
          }
        }
      }
      this.$emit('change', this.options);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/Customization.vue